import { render, staticRenderFns } from "./ppedetails.vue?vue&type=template&id=0148f640"
import script from "./ppedetails.vue?vue&type=script&lang=js"
export * from "./ppedetails.vue?vue&type=script&lang=js"
import style0 from "./ppedetails.vue?vue&type=style&index=0&id=0148f640&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports